// The faint streets of a city at night behind a dark hero (landing page, About
// us), fading out towards the edges. Decoration: hidden from screen readers.
//   focus: where the streets show most (default right of the landing page's words)
//   align: which part of the drawing stays in view on narrow screens (SVG
//          preserveAspectRatio, with slice)
import React from 'react';
import { Box } from '@mui/material';

export default function CityStreets({ focus = '60% 45%', align = 'xMaxYMid' }) {
  const mask = `radial-gradient(75% 70% at ${focus}, #000 30%, transparent 85%)`;
  return (
    <Box aria-hidden sx={{ position: 'absolute', inset: 0, pointerEvents: 'none', WebkitMaskImage: mask, maskImage: mask }}>
      <svg width="100%" height="100%" viewBox="0 0 1440 900" preserveAspectRatio={`${align} slice`}>
        <g fill="none" stroke="rgba(255,255,255,0.07)" strokeLinecap="round">
          <path d="M-40 640 C 220 600, 360 700, 620 640 S 1040 520, 1500 580" strokeWidth="14" />
          <path d="M-40 300 C 260 340, 420 220, 700 260 S 1120 380, 1500 300" strokeWidth="10" />
          <path d="M380 -40 C 360 200, 470 420, 430 940" strokeWidth="12" />
          <path d="M980 -40 C 1010 240, 900 520, 1000 940" strokeWidth="10" />
          <path d="M-40 120 L 1500 210" strokeWidth="5" />
          <path d="M-40 800 L 1500 740" strokeWidth="5" />
          <path d="M160 -40 L 240 940" strokeWidth="4" />
          <path d="M720 -40 L 650 940" strokeWidth="4" />
          <path d="M1240 -40 L 1300 940" strokeWidth="4" />
          <path d="M520 940 C 640 700, 820 640, 1500 470" strokeWidth="6" />
        </g>
      </svg>
    </Box>
  );
}
